/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResponseDto_String } from '../models/ResponseDto_String';
import type { YtdImportSampleDownloadResponse } from '../models/YtdImportSampleDownloadResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class YtdService {

    /**
     * @param formData 
     * @returns ResponseDto_String OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppYtdImportYtd(
formData?: {
ImportFile?: Blob;
},
): CancelablePromise<ResponseDto_String> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/ytd/import-ytd',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns YtdImportSampleDownloadResponse OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppYtdDownloadYtdImportSample(): CancelablePromise<YtdImportSampleDownloadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/ytd/download-ytd-import-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
